import {useListView} from '../../core/ListViewProvider'
import {UserActivitiesToolbar} from './UserActivitiesListToolbar'
import {UserActivitiesGrouping} from './UserActivitiesListGrouping'

const UserActivitiesListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <UserActivitiesGrouping /> : <UserActivitiesToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {UserActivitiesListHeader}
